import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-analytics',
  templateUrl: './icon-analytics.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconAnalyticsComponent {}
